import {striphtml} from './stripHtml'

export default {
    install(Vue, options) {
        Vue.filter('striphtml', striphtml);
    },
};